<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <b-field
      :label="label"
      :type="{ 'is-danger': errors.length > 0 }"
      :message="errors[0]"
    >
      <b-datepicker
        :date-formatter="formatDate"
        v-bind="$attrs"
        v-on="$listeners"
        icon="calendar-today"
        v-model="item"
        @input="$emit('input', item)"
      />
    </b-field>
  </ValidationProvider>
</template>

<script>
import { format } from "date-fns";

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: null
    },
    value: {
      type: [Date, String]
    }
  },
  methods: {
    formatDate(date) {
      return format(date, "dd/MM/yyyy");
    },
    setDate(value) {
      if (typeof value === "string") {
        return new Date(value);
      }
      return value;
    }
  },
  data() {
    return {
      item: this.setDate(this.value)
    };
  }
};
</script>